import { FC } from 'react'
import { SvgProps } from './svgProps'

const CartAddIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 18}
    height={height || 18}
    viewBox="0 0 18 18"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H17V17H0z"
        transform="translate(-634.000000, -133.000000) translate(634.000000, 133.000000)"
      />
      <g stroke={color || '#FFF'} strokeLinecap="round" strokeWidth="1.5">
        <path
          d="M8.5 14.45H4.241c-1.466 0-2.718-1.06-2.959-2.507l-.7-4.2c-.272-1.634.832-3.18 2.466-3.452.163-.027.328-.041.493-.041h8.815c1.657 0 3 1.343 3 3 0 .157-.012.313-.037.468l-.302 1.915h0"
          transform="translate(-634.000000, -133.000000) translate(634.000000, 133.000000) translate(0.566667, 0.283333)"
        />
        <path
          d="M3.4 4.25l3.165-2.968c.77-.72 1.967-.72 2.736 0l3.166 2.968h0"
          transform="translate(-634.000000, -133.000000) translate(634.000000, 133.000000) translate(0.566667, 0.283333)"
        />
        <g transform="translate(-634.000000, -133.000000) translate(634.000000, 133.000000) translate(0.566667, 0.283333) translate(7.933333, 8.216667)">
          <circle cx="3.967" cy="3.967" r="3.967" />
          <path d="M2.833 4.25l.773.773c.039.039.102.039.141 0l.006-.007L5.1 3.4h0" />
        </g>
      </g>
    </g>
  </svg>
)

export default CartAddIcon
